"use client";

import { createClient } from "@/lib/supabase/client";
import { Button } from "@/components/ui/button";

const GOOGLE_ICON = (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
    <path
      fill="#EA4335"
      d="M5.27 9.76A7.08 7.08 0 0 1 12 4.9c2.04 0 3.86.74 5.3 1.96l3.94-3.94C18.98 1.2 15.74 0 12 0 7.36 0 3.35 2.6 1.35 6.43l3.92 3.33Z"
    />
    <path
      fill="#34A853"
      d="M16.04 18.84A7.41 7.41 0 0 1 12 19.93a7.43 7.43 0 0 1-6.99-4.88l-3.95 3.03A11.94 11.94 0 0 0 12 24c2.97 0 5.79-1.06 7.96-3.06l-3.92-2.1Z"
    />
    <path
      fill="#4A90E2"
      d="M19.96 20.94c2.18-2.04 3.6-5.08 3.6-8.94 0-.76-.06-1.51-.17-2.21H12v4.18h6.59c-.32 1.64-1.29 3.02-2.59 3.94l3.96 3.03Z"
    />
    <path
      fill="#FBBC05"
      d="M5.01 14.05A7.45 7.45 0 0 1 4.55 12c0-.71.14-1.39.37-2.02L.98 6.66A11.94 11.94 0 0 0 0 12c0 1.93.46 3.74 1.27 5.34l3.74-3.29Z"
    />
  </svg>
);

const MICROSOFT_ICON = (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
    <path fill="#F25022" d="M1 1h10v10H1z" />
    <path fill="#7FBA00" d="M13 1h10v10H13z" />
    <path fill="#00A4EF" d="M1 13h10v10H1z" />
    <path fill="#FFB900" d="M13 13h10v10H13z" />
  </svg>
);

export function SSOButtons({ mode }: { mode: "login" | "signup" }) {
  async function signInWith(provider: "google" | "azure") {
    const supabase = createClient();
    const { error } = await supabase.auth.signInWithOAuth({
      provider,
      options: { redirectTo: `${window.location.origin}/auth/callback` },
    });
    if (error) console.error("[sso]", error);
  }

  const label = mode === "login" ? "Sign in with" : "Continue with";

  return (
    <div className="space-y-2.5">
      <Button
        type="button"
        variant="outline"
        className="w-full justify-center gap-2.5"
        onClick={() => signInWith("google")}
      >
        {GOOGLE_ICON}
        {label} Google
      </Button>
      <Button
        type="button"
        variant="outline"
        className="w-full justify-center gap-2.5"
        onClick={() => signInWith("azure")}
      >
        {MICROSOFT_ICON}
        {label} Microsoft
      </Button>
      <div className="relative my-4">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t border-[var(--glass-border)]" />
        </div>
        <div className="relative flex justify-center text-caption uppercase">
          <span className="bg-background px-2 text-muted-foreground">
            or continue with email
          </span>
        </div>
      </div>
    </div>
  );
}
